export default __webpack_public_path__ + "static/media/buyerIcon.81d65348.svg";